/* CA mirror of US store improvements - Oct 2026 */
(function () {
  var SALE_HANDLE = 'up-to-70-off';
  var SALE = '/collections/' + SALE_HANDLE;
  function ready(f) { if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }

  /* 1. Announcement ticker: speed by length, pause on touch */
  ready(function () {
    var t = document.querySelector('.cam-ticker'); if (!t) return;
    var tr = t.querySelector('.cam-ticker__track');
    if (tr) { var w = tr.scrollWidth / 2; tr.style.setProperty('--cam-dur', Math.max(20, Math.round(w / 45)) + 's'); }
    var timer;
    t.addEventListener('touchstart', function () { clearTimeout(timer); t.classList.add('is-paused'); }, { passive: true });
    t.addEventListener('touchend', function () { timer = setTimeout(function () { t.classList.remove('is-paused'); }, 2500); }, { passive: true });
  });

  /* 2. Region bar: shown to US visitors only */
  ready(function () {
    var b = document.querySelector('[data-cam-region]'); if (!b) return;
    function apply(c) { if (c === 'US') b.hidden = false; }
    try { var c = sessionStorage.getItem('camCountry'); if (c !== null) { apply(c); return; } } catch (e) {}
    fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }).then(function (j) {
      var c = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
      c = String(c).toUpperCase();
      try { sessionStorage.setItem('camCountry', c); } catch (e) {}
      apply(c);
    }).catch(function () {});
  });

  /* 3. Collections: Sort by menu, biggest-discount sort, Featured = daily shuffle on sale */
  function onCollection() { return /^\/collections\/[^\/]+\/?$/.test(location.pathname); }
  function handle() { return location.pathname.replace(/\/$/, '').split('/')[2]; }
  function sortParam() { return new URLSearchParams(location.search).get('sort_by') || ''; }
  function refreshColors() {
    if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) AP_COLOR_MAP.applyAll();
    if (typeof initCollectionColorMatch === 'function') initCollectionColorMatch();
  }
  function loadAll(grid) {
    var btn = document.querySelector('[data-load-more]');
    var next = btn ? btn.getAttribute('data-next-url') : null, pages = 1;
    function step() {
      if (!next || pages >= 20) return Promise.resolve();
      return fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.querySelector('[data-product-grid]');
        if (ng) while (ng.children.length) grid.appendChild(ng.children[0]);
        var nb = doc.querySelector('[data-load-more]');
        next = nb ? nb.getAttribute('data-next-url') : null; pages++; return step();
      });
    }
    return step().then(function () { var w = document.querySelector('[data-load-more-wrap]'); if (w) w.style.display = 'none'; });
  }
  function pct(card) { var b = card.querySelector('.s-product-card__badge'); var n = b ? parseInt(b.textContent, 10) : 0; return isNaN(n) ? 0 : n; }
  function sortByDiscount(grid) {
    var cards = [].slice.call(grid.children).map(function (c, i) { return { c: c, p: pct(c), i: i }; });
    cards.sort(function (a, b) { return (b.p - a.p) || (a.i - b.i); });
    cards.forEach(function (o) { grid.appendChild(o.c); });
    refreshColors();
  }
  function dailyShuffle(grid) {
    var d = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto' }), s = 0;
    for (var i = 0; i < d.length; i++) s = (s * 31 + d.charCodeAt(i)) >>> 0;
    function rnd() { s = (s + 0x6D2B79F5) >>> 0; var t = s; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }
    var cards = [].slice.call(grid.children);
    for (var k = cards.length - 1; k > 0; k--) { var j = Math.floor(rnd() * (k + 1)); var tmp = cards[k]; cards[k] = cards[j]; cards[j] = tmp; }
    cards.forEach(function (c) { grid.appendChild(c); });
    refreshColors();
  }
  var isSale = onCollection() && handle() === SALE_HANDLE;
  /* Sale default (no params): load every page, deepest discount first */
  if (isSale && !location.search) {
    ready(function () { var g = document.querySelector('[data-product-grid]'); if (!g) return; g.style.opacity = '0'; loadAll(g).then(function () { sortByDiscount(g); }).catch(function () {}).then(function () { g.style.opacity = ''; }); });
  }
  ready(function () {
    if (!onCollection()) return;
    var cnt = document.querySelector('[data-product-count]'); if (!cnt || document.querySelector('.cam-toolbar')) return;
    var cur = sortParam();
    var opts = isSale ? [['manual', 'Featured'], ['', 'Biggest discount']] : [['', 'Featured']];
    opts = opts.concat([['price-descending', 'Price: High to Low'], ['price-ascending', 'Price: Low to High'], ['best-selling', 'Best Selling'], ['created-descending', 'Newest']]);
    var bar = document.createElement('div'); bar.className = 'cam-toolbar';
    cnt.parentNode.insertBefore(bar, cnt); bar.appendChild(cnt);
    var lab = document.createElement('label'); lab.className = 'cam-sort'; lab.innerHTML = '<span>Sort by</span>';
    var sel = document.createElement('select'); sel.setAttribute('aria-label', 'Sort by');
    opts.forEach(function (o) { var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; if (o[0] === cur) op.selected = true; sel.appendChild(op); });
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      if (sel.value) u.searchParams.set('sort_by', sel.value); else u.searchParams.delete('sort_by');
      u.searchParams.delete('page'); location.href = u.toString();
    });
    lab.appendChild(sel); bar.appendChild(lab);
    /* Sale + Featured: same daily shuffle as before */
    if (isSale && cur === 'manual') {
      var g = document.querySelector('[data-product-grid]');
      if (g) { g.style.opacity = '0'; loadAll(g).then(function () { dailyShuffle(g); }).catch(function () {}).then(function () { g.style.opacity = ''; }); }
    }
  });

  /* 4. Cart page + cart drawer: final-sale notice above Checkout, Buy 5 Get 1 promo message */
  function flags() {
    return fetch('/?sections=cam-cart-flags', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var d = document.createElement('div'); d.innerHTML = j['cam-cart-flags'] || '';
      var el = d.querySelector('[data-cam-flags]'); return el ? JSON.parse(el.textContent) : { promo: 0, final: 0, items: 0 };
    });
  }
  function promoHtml(n) {
    var head = '<b>Buy any 5 sale items, get the 6th FREE</b>';
    if (n >= 6) return '<b>Your 6th sale item is FREE</b>Discount applied automatically at checkout.';
    if (n > 0) { var need = 6 - n; return head + 'You have ' + n + ' sale item' + (n === 1 ? '' : 's') + ' in your cart. Add ' + need + ' more and the 6th is free. <a href="' + SALE + '">Shop the sale</a>'; }
    return head + 'Applied automatically at checkout. <a href="' + SALE + '">Shop the sale</a>';
  }
  var FINAL = 'Sale items are final sale \u2013 no returns or exchanges.';
  function box(cls, parent, before) {
    var b = parent.querySelector('.' + cls);
    if (!b) { b = document.createElement('div'); b.className = 'cam-note ' + cls; b.hidden = true; if (before && before.parentNode) before.parentNode.insertBefore(b, before); else parent.appendChild(b); }
    return b;
  }
  function paint(promoBox, finalBox) {
    return flags().then(function (f) {
      if (promoBox) { var h = f.items > 0 ? promoHtml(f.promo) : ''; promoBox.hidden = !h; if (promoBox.getAttribute('data-h') !== h) { promoBox.innerHTML = h; promoBox.setAttribute('data-h', h); } }
      if (finalBox) { finalBox.hidden = !(f.final > 0); finalBox.textContent = FINAL; }
    }).catch(function () {});
  }
  function watch(root, fn) {
    var t;
    new MutationObserver(function (ms) {
      if (ms.every(function (m) { var n = m.target.nodeType === 1 ? m.target : m.target.parentNode; return n && n.closest && n.closest('.cam-note'); })) return;
      clearTimeout(t); t = setTimeout(fn, 450);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }
  ready(function () {
    var sec = document.querySelector('.s-cart');
    if (sec && sec.querySelector('[data-cart-items]')) {
      var run = function () {
        var hdr = sec.querySelector('.s-cart__header');
        var form = sec.querySelector('.s-cart__footer-right form');
        paint(box('cam-note--promo', sec.querySelector('.container') || sec, hdr ? hdr.nextSibling : null),
              form ? box('cam-note--final', form.parentNode, form) : null);
      };
      run(); watch(sec, run);
    }
    var d = document.querySelector('[data-cart-drawer]');
    if (d) {
      var runD = function () {
        var main = d.querySelector('.s-cart-drawer__main') || d;
        paint(box('cam-note--promo', main, d.querySelector('.s-cart-drawer__subtotal')),
              box('cam-note--final', main, d.querySelector('.s-cart-drawer__actions')));
      };
      runD(); watch(d, runD);
    }
  });
  /* 5. Swatch colour fix: Nu Green = #84BCA0 (mint, not olive). Re-applied whenever theme scripts repaint swatches. */
  var HEX_FIX = { 'nu green': '#84BCA0' };
  function norm(n) { return String(n || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function fixSwatch(el) {
    var hex = HEX_FIX[norm(el.getAttribute('data-color-name'))];
    if (hex && el.style.backgroundColor !== 'rgb(132, 188, 160)') { el.style.backgroundImage = ''; el.style.backgroundColor = hex; }
  }
  function fixAll(root) { [].forEach.call((root || document).querySelectorAll('[data-color-name]'), fixSwatch); }
  ready(function () {
    fixAll();
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.hasAttribute && m.target.hasAttribute('data-color-name')) fixSwatch(m.target); }
        else [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) { if (n.hasAttribute('data-color-name')) fixSwatch(n); fixAll(n); } });
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'data-color-name'] });
  });
})();
